<div class="avverkningsanmalan-samrad__container">
  @if (avverkningsanmalanButtonsVisible) {
    <div class="row">
      <div class="col">
        <rask-radiobutton-group label="Kräver åtgärden avverkningsanmälan eller samråd?" [verticalLayout]="true"
          [disabled]="kontraktReadonly"
          [(ngModel)]="avverkningsanmalanKravs"
          (change)="onAvverkningsanmalanKravsChange($event)"
          [buttons]="[{ key: true, value: 'Ja, avverkningsanmälan/samråd krävs. Dokumentation bifogas under &quot;Tillagda filer&quot;.' }, { key: false, value: 'Åtgärden kräver ej avverkningsanmälan/samråd' }]">
        </rask-radiobutton-group>
      </div>
    </div>
  }

  @if (!fileUploadVisible) {
    <div class="row">
      <div class="col text-end">
        <rask-button color="secondary" (click)="onContinueClick()"
          [disabled]="!avverkningsanmalanKravs || kontraktReadonly || !avverkningsanmalanButtonsVisible">
          Fortsätt
        </rask-button>
      </div>
    </div>
  }
  @if (fileUploadVisible) {
    <div class="row">
      <div class="col-12 text-end">
        @if (!kontraktReadonly && avverkningsanmalanButtonsVisible) {
          <rask-button color="secondary" negative (click)="onCancelClick()"
            >
            Avbryt
          </rask-button>
        }
      </div>
      <div class="col-12">
        <rask-kontrakt-dokument
          #dokumentAvverkningsanmalanSamrad
          [dokumenttyp]="blobStorageDokumentTypAvverkningsanmalanSamradBilaga"
          [isForKontrakt]="false"
          (fileUpload)="onFileUpload()"
          [deleteFileEnabled]="enableDeleteFile"
          [atgardId]="atgard.id"
          [multiple]="true">
        </rask-kontrakt-dokument>
      </div>
    </div>
  }
</div>